import { Checkbox } from '~/components/UI/shadcn/checkbox'
import { Label } from '~/components/UI/shadcn/label'

import { useQuery } from '@tanstack/react-query'
import { getFilters } from '~/components/Content/Filters/data'
import Loader from '../../General/Loader/Loader'
import { useQueryState, parseAsArrayOf, parseAsString } from 'nuqs'

type CheckboxProps = {
  data: {
    label?: string
    required: boolean
    note?: string
  }
  items?:
    | {
        label?: string
        id?: string
      }
    | {
        items: { id: string; label: string }[]
      }
  disabled: true | false
  queryKey?: string
}

const Checkboxes = (props: CheckboxProps) => {
  const [query = [], setQuery] = useQueryState<string[]>(
    props.queryKey || 'filters',
    parseAsArrayOf(parseAsString, ',')
  )

  const { disabled, data, items } = props
  const id = items && 'id' in items ? items.id : undefined
  const normalisedQuery = query || []

  const { data: filterData, isLoading } = useQuery({
    queryKey: [id],
    queryFn: () => getFilters(id || ''),
    enabled: !!id // Only fetch if id exists
  })

  const toggleValue = (value: string) => {
    setQuery(prev =>
      prev?.includes(value)
        ? prev.filter(v => v !== value)
        : [...(prev || []), value]
    )
  }

  if (isLoading) {
    return (
      <div>
        <Loader fill={'#f5b6dc'} />
      </div>
    )
  }

  return (
    <div className='space-y-xs'>
      {data?.label && (
        <Label className='flex justify-between'>
          {data.label}{' '}
          {data?.required && <span className='text-blue-m'>*</span>}
        </Label>
      )}
      <div className='gap-xs grid'>
        {filterData &&
          'items' in filterData &&
          Array.isArray(filterData.items) &&
          filterData.items.map(item => (
            <div key={item.id} className='space-x-xs flex items-center'>
              <Checkbox
                id={item.id}
                aria-label={item.label}
                className='hover:border-blue-m dark:hover:border-white'
                disabled={disabled || false}
                checked={normalisedQuery.includes(item.id)}
                onCheckedChange={() => toggleValue(item.id)}
              />
              <Label
                htmlFor={item.id}
                className='peer-disabled:text-grey-m cursor-pointer text-base font-normal peer-hover:underline peer-disabled:cursor-not-allowed peer-disabled:no-underline peer-disabled:opacity-100'
              >
                {item.label}
              </Label>
            </div>
          ))}

        {'items' in (items ?? {}) &&
          Array.isArray(
            (items as { items: { id: string; label: string }[] }).items
          ) &&
          (items as { items: { id: string; label: string }[] }).items.map(
            item => (
              <div key={item.id} className='space-x-xs flex items-center'>
                <Checkbox
                  id={item.id}
                  aria-label={item.label}
                  className='hover:border-blue-m dark:hover:border-white'
                  disabled={disabled || false}
                  checked={normalisedQuery.includes(item.id)}
                  onCheckedChange={() => toggleValue(item.id!)}
                />
                <Label htmlFor={item.id}>{item.label}</Label>
              </div>
            )
          )}
      </div>
      {data?.note && <p className='text-xs'>{data?.note}</p>}
    </div>
  )
}

export default Checkboxes
